// Compute maintenance status per unit given intervals table.
export function getIntervalFor(type, intervals) {
  if (!type || !intervals) return null;
  const t = String(type).toLowerCase();
  const match = intervals.find((i) => String(i.type || "").toLowerCase() === t);
  return match || null;
}

export function computeMaintStatus(unit, intervals) {
  if (!unit || unit.archived) return { key: "archived", label: "Archived" };
  const interval = getIntervalFor(unit.type, intervals);
  if (!interval) return { key: "ok", label: "OK" };

  // Trailer -> annual only
  if (interval.miles == null && interval.hours == null) {
    if (!unit.nextAnnualInspection) return { key: "needs_data", label: "Needs Data" };
    const days = daysUntil(unit.nextAnnualInspection);
    if (days == null) return { key: "needs_data", label: "Needs Data" };
    if (days < 0) return { key: "overdue", label: "Overdue" };
    if (days <= 30) return { key: "due_soon", label: "Due Soon" };
    return { key: "ok", label: "OK" };
  }

  if (interval.miles) {
    if (unit.mileage == null) return { key: "needs_data", label: "Needs Data" };
    const last = unit.lastServiceMileage ?? 0;
    const due = last + interval.miles;
    const remaining = due - unit.mileage;
    if (remaining <= 0) return { key: "overdue", label: "Overdue" };
    if (remaining <= interval.miles * 0.1) return { key: "due_soon", label: "Due Soon" };
    return { key: "ok", label: "OK" };
  }

  if (interval.hours) {
    if (unit.hours == null) return { key: "needs_data", label: "Needs Data" };
    const last = unit.lastServiceHours ?? 0;
    const due = last + interval.hours;
    const remaining = due - unit.hours;
    if (remaining <= 0) return { key: "overdue", label: "Overdue" };
    if (remaining <= interval.hours * 0.1) return { key: "due_soon", label: "Due Soon" };
    return { key: "ok", label: "OK" };
  }
  return { key: "ok", label: "OK" };
}

export function daysUntil(iso) {
  if (!iso) return null;
  try {
    const d = parseDate(iso);
    if (!d || isNaN(d)) return null;
    const now = new Date();
    return Math.floor((d - now) / (1000 * 60 * 60 * 24));
  } catch { return null; }
}

// Parse "YYYY-MM-DD" as a LOCAL calendar date (not UTC midnight),
// so display doesn't shift to the previous day in west-of-UTC timezones.
// Full ISO datetimes ("...T...") are parsed as-is.
function parseDate(iso) {
  if (iso == null) return null;
  const s = String(iso);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(s);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = parseDate(iso);
    if (!d || isNaN(d)) return String(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return String(iso); }
}

export function fmtNum(n) {
  if (n == null || n === "") return "—";
  const v = Number(n);
  if (isNaN(v)) return String(n);
  return v.toLocaleString("en-US");
}

export const STATUS_COLORS = {
  ok:         { badge: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30", dot: "bg-emerald-400" },
  due_soon:   { badge: "bg-amber-500/10 text-amber-400 border-amber-500/30", dot: "bg-amber-400" },
  overdue:    { badge: "bg-red-500/10 text-red-400 border-red-500/30", dot: "bg-red-400" },
  needs_data: { badge: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30", dot: "bg-cyan-400" },
  archived:   { badge: "bg-zinc-500/10 text-zinc-400 border-zinc-500/30", dot: "bg-zinc-400" },
};
